import {HttpClient, HttpClientModule} from '@angular/common/http';
import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {Camera} from '@ionic-native/camera';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';
import {IonicStorageModule} from '@ionic/storage';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {IonicApp, IonicErrorHandler, IonicModule, Config} from 'ionic-angular';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {MyApp} from './app.component';

import {File} from '@ionic-native/file';
import {FileTransfer} from "@ionic-native/file-transfer";
import {FileOpener} from "@ionic-native/file-opener";
import {ImagePicker} from "@ionic-native/image-picker";
import {Geolocation} from '@ionic-native/geolocation';
import {IonicImageLoader} from 'ionic-image-loader';
import {AppVersion} from '@ionic-native/app-version';
import {InAppBrowser} from '@ionic-native/in-app-browser';
import {Network} from "@ionic-native/network";
import {MultiPickerModule} from 'ion-multi-picker';
import {ApiService, ImgService, NativeService, NoticeService, NetworkService, ImageService} from '../providers/providers';
import {
  CartService,
  CategoryService,
  OrderService,
  SaleService,
  UserService,
  LotteryService,
  MoveshopService,
  SocialService,
  ArticleService,CropService,
} from '../providers/providers';

import {Clipboard} from '@ionic-native/clipboard';
import {OpenNativeSettings} from '@ionic-native/open-native-settings';
// import {Keyboard} from "@ionic-native/keyboard";
// Transitions
// import {ProgressBarModule} from "angular-progress-bar";
import {
  ModalSlideRightEnterTransition,
  ModalSlideLeftLeaveTransition,
  ModalScaleUpLeaveTransition,
  ModalScaleUpEnterTransition,
  ModalSlidTopEnterTransition,
  ModalSlideTopLeaveTransition
} from "../transitions/transitions";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {JPush} from "@jiguang-ionic/jpush";
import { Contacts, Contact, ContactField, ContactName } from '@ionic-native/contacts';
import { WebView } from '@ionic-native/ionic-webview/ngx';
import { PhotoLibrary } from '@ionic-native/photo-library';


import {ProgressBarModule} from "angular-progress-bar";


// import Jimp from 'jimp';
// The translate loader needs to know where to load i18n files
// in Ionic's static asset pipeline.
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    MultiPickerModule,
    BrowserModule,
    ProgressBarModule,
    // Jimp,
    BrowserAnimationsModule,LazyLoadImageModule,
    HttpClientModule,
    IonicImageLoader.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    IonicModule.forRoot(MyApp, {
      backButtonText: '',
      tabsHideOnSubPages: true,//进入子页面隐藏tabs
      platforms: {
        ios: {
          scrollAssist: true,
          autoFocusAssist: true,
          scrollPadding: true
        }
      }
    }),
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    Camera,
    SplashScreen,
    StatusBar,
    Network,
    AppVersion,
    File,
    Geolocation,
    InAppBrowser,
    Camera,
    FileTransfer,
    ImagePicker,
    FileOpener,
    Clipboard,
    // Keyboard,
    JPush,Contacts,
    OpenNativeSettings,
    // Keep this to enable Ionic's runtime error handling during development
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ApiService, ImgService, NativeService, NoticeService, NetworkService,
    CartService, CategoryService, OrderService, SaleService, UserService,
    LotteryService, MoveshopService, SocialService,
    ArticleService,
    ImageService,
    PhotoLibrary,
    CropService,WebView,
  ]
})
export class AppModule {
  constructor(public config: Config) {
    this.setCustomTransitions();
  }

  private setCustomTransitions() {
    this.config.setTransition('modal-scale-up-leave', ModalScaleUpLeaveTransition);
    this.config.setTransition('modal-scale-up-enter', ModalScaleUpEnterTransition);
    this.config.setTransition('modal-slide-right-enter', ModalSlideRightEnterTransition);
    this.config.setTransition('modal-slide-left-leave', ModalSlideLeftLeaveTransition);
    this.config.setTransition('modal-slide-top-enter', ModalSlidTopEnterTransition);
    this.config.setTransition('modal-slide-top-leave', ModalSlideTopLeaveTransition);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts